export default __webpack_public_path__ + "media/images/celeste_list-8f81ffc644f41b9fb7e949fcecea24d9.png";